import { remove } from 'lodash/fp';
import React, { FC, useEffect, useState } from 'react';

import { PartnerIncidentType } from '@portals/api/partners';
import {
  PaginatedFilterTypeEnum,
  PaginatedQueryParamsType,
} from '@portals/types';

import { ListWithActions } from './ListWithActions';
import { ItemType } from './TicketOrIncidentItem';

const INITIAL_STATE_PARAMS: PaginatedQueryParamsType<PartnerIncidentType> = {
  sorting: [{ id: 'created_at', desc: false }],
  pagination: {
    page: 0,
    pageSize: 10,
  },
  filters: [
    { id: 'status', value: 'active', type: PaginatedFilterTypeEnum.Eq },
  ],
};

interface IncidentsListProps {
  endpointUrl: string;
  itemsKey: string;
  viewAllLink?: string;
  closeModal?: () => void;
  organizationId?: string;
  isLabIncluded?: boolean;
}

export const IncidentsList: FC<IncidentsListProps> = ({
  endpointUrl,
  viewAllLink,
  itemsKey,
  closeModal,
  organizationId,
  isLabIncluded = false,
}) => {
  const initialStateParams = organizationId
    ? {
        ...INITIAL_STATE_PARAMS,
        filters: [
          ...INITIAL_STATE_PARAMS.filters,
          {
            id: 'organization_id',
            value: organizationId,
            type: PaginatedFilterTypeEnum.Eq,
          },
        ],
      }
    : INITIAL_STATE_PARAMS;

  const [incidentsParams, setIncidentsParams] = useState(initialStateParams);
  const [incidentsSortBy, setIncidentsSortBy] = useState('created_at');

  useEffect(
    function onLabInclusionChange() {
      setIncidentsParams((incidentsParams) => ({
        ...incidentsParams,
        filters: isLabIncluded
          ? remove({ id: 'organization_lab' }, incidentsParams.filters)
          : [
              ...incidentsParams.filters,
              {
                id: 'organization_lab',
                value: 'false',
                type: PaginatedFilterTypeEnum.Eq,
              },
            ],
      }));
    },
    [isLabIncluded]
  );

  const onSortByChanged = (sortBy: string) => {
    setIncidentsSortBy(sortBy);

    setIncidentsParams({
      ...incidentsParams,
      sorting: [{ id: sortBy, desc: false }],
    });
  };

  return (
    <ListWithActions
      showSortBySeverity
      viewAllLink={viewAllLink}
      onSortByChanged={onSortByChanged}
      selectedItem={incidentsSortBy}
      itemsParams={incidentsParams}
      itemType={ItemType.Incident}
      itemsKey={itemsKey}
      endpointUrl={endpointUrl}
      emptyStateLabel="No active incidents"
      closeModal={closeModal}
    />
  );
};
